module.exports = __webpack_public_path__ + "src/images/products/prep/23_1984 Striped Cotton-Jersey Polo.png";